<template>
  <div>
    <h4 class="mb-4">RTPs List</h4>
    <app-board :header="false" class="p-3 mb-3">
      <div class="row mb-3">
        <div class="col-12 col-md-6">
          <span class="ag-grid-quick-search-label">Search</span>
          <span><el-input class="d-inline-block w-50" v-model="searchMe" size='mini'></el-input></span>
        </div>
      </div>
    </app-board>

    <module-list-layout :createAction="createAction" :header="false" :module="module" class="">
      <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
        <moduleForm
            :bindingForView="true"
            :dataToBind="dataToBind"
            :edit-mode="editMode"
            :on-create-callback="afterCreate"
            :on-edit-callback="afterEdit"
            v-if="dialogVisible"></moduleForm>
      </el-dialog>

      <app-ag-grid :agGrid="agGrid"></app-ag-grid>
    </module-list-layout>
  </div>
</template>

<script>
import Vue from 'vue'
import actionsCell from './ag-grid/ActionsCell'
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  watch: {
    searchMe: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  components: {
    moduleForm: () => import('./../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  data () {
    return {
      searchMe: null,
      module: {
        ...module
      },
      editMode: false,
      dialogVisible: false,
      rowsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: true,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            setTimeout(() => {
              params.api.sizeColumnsToFit()
            }, 200)
          }
        },
        columnDefs: [
          {
            field: 'destination',
            headerName: "Destination",
            autoHeight: true,
            headerClass: this.$langConfig.cssClass
          },
          {
            field: 'vendor',
            headerName: 'Vendor',
            autoHeight: true,
            headerClass: this.$langConfig.cssClass
          },
          {
            width: 100,
            field: 'rtp',
            headerName: 'RTP',
            autoHeight: true,
            headerClass: this.$langConfig.cssClass
          },
          /*{
            width: 80,
            headerName: 'Actions',
            headerClass: this.$langConfig.cssClass,
            cellRendererFramework: Vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }*/
        ],
        rowData: []
      }
    };
  },
  mounted () {
    this.$store.dispatch(this.module.info.name + '-api/list').then(response => {
      this.agGrid.rowData = response;
      console.log(response[0])
      this.rowsCounter = response.length;
    })
  },
  methods: {
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.rowsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
